import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";

export default function CustomTabs(props) {
  const { t } = useTranslation();
  const {
    tabs,
    selected,
    handleChange = () => {},
    itemProps = {},
    containerProps = {},
  } = props;
  return (
    <div
      className={`filter-tabs px-1 ${
        containerProps.className ? containerProps.className : ""
      }`}
    >
      {tabs.map((item, index) => (
        <div
          key={index}
          onClick={() => handleChange(item)}
          {...itemProps}
          className={`chat-filter-item ${
            item.value === selected ? "selected" : ""
          } ${itemProps.className ? itemProps.className : ""}`}
        >
          <Icon icon={item.icon} />
          <div className="filter-item-title">
            {item.titleKey ? t(item.titleKey) : item.title}
          </div>
        </div>
      ))}
    </div>
  );
}
